import clsx from 'clsx'

interface CostBreakdownItemProps {
  label: string
  value: string
  description?: string
  variant?: 'default' | 'bold' | 'subdued'
  indented?: boolean
  valueClassName?: string
}

export function CostBreakdownItem ({
  label,
  value,
  description,
  variant = 'default',
  indented = false,
  valueClassName: customValueClassName,
}: CostBreakdownItemProps) {
  const labelClassName = clsx({
    'body-bold text-gray-800': variant === 'bold',
    'body-sm text-subdued': variant === 'subdued',
    'body text-gray-800': variant === 'default',
  })
  const valueClassName = customValueClassName
    ? clsx('text-right', customValueClassName)
    : clsx('text-right', {
      'body-bold text-gray-800': variant === 'bold',
      'body-sm text-subdued': variant === 'subdued',
      'body text-gray-800': variant === 'default',
    })

  return (
    <div className={clsx({ 'ml-4': indented })}>
      <div className='flex items-center w-full'>
        <span className={labelClassName}>
          {label}
        </span>
        <div className='grow shrink-0 min-w-4 border-b-2 border-dotted border-gray-300 mx-2' style={{ height: 0 }} />
        <span className={valueClassName}>
          {value}
        </span>
      </div>
      {description && (
        <div className='body-sm text-gray-500 mt-1'>{description}</div>
      )}
    </div>
  )
}
